<ng-template #deviceDetail let-control>
  <cue-controllable-objects
    class="!mt-0"
    [qrCodeListOfResource]="control.qrCodes | qrIdList"
    [objectList]="control.objects"
    [qrCodeId]="control.qrCodeId"
  />
</ng-template>

<div class="w-full h-full">
  @if (controls()?.length === 1) {
    <cue-poi [poi]="controls()[0].poi" link="false" class="mb-3" />
    <ng-container *ngTemplateOutlet="deviceDetail; context: { $implicit: controls()[0] }" />
  } @else {
    @for (control of controls(); track $index) {
      <kendo-expansionpanel
        class="show-panel w-full"
        expandIcon="k-icon k-font-icon k-i-plus"
        collapseIcon="fa fa-minus"
      >
        <ng-template kendoExpansionPanelTitleDirective>
          <cue-poi [poi]="control.poi" link="false" />
        </ng-template>

        <ng-container *ngTemplateOutlet="deviceDetail; context: { $implicit: control }" />
      </kendo-expansionpanel>
    }
  }
</div>
